import React from "react";
import banner from "../../../assets/images/ncici/banner-bg.jpg";
const Banner = () => {
  return (
    <div className="relative h-[680px] md:h-[550px] ">
      <div className="  md:px-10 absolute py-3  h-[650px] md:h-96 lg:h-[500px]  w-full">
        <img
          src={banner}
          className=" h-[650px] md:h-96 lg:h-[500px] w-full bg-[rgba(0,0,0,0.3)] md:rounded-xl object-cover "
          alt=""
        />
      </div>
      <div className="  md:px-10 absolute  py-3  h-[650px] md:h-96 lg:h-[500px] w-full">
        <div
          className=" h-[650px] md:h-96 lg:h-[500px] md:rounded-xl w-full flex flex-col items-center justify-center bg-[rgba(0,0,0,0.3)]  "
          alt=""
        >
          <h1 className="text-white text-3xl titlefont ">
            ✿ Welcome from NCC ✿
          </h1>
          <p className="text-white text-center text-base textfont mt-4">
            Lorem ipsum dolor sit amet consectetur adipisicing elit.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Banner;
